import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IActionMessageProps = {
  name: string
  placeholder: string
  message?: string
}

export const ActionMessage = observer(({ name, placeholder, message }: IActionMessageProps) => {
  return (
    <div className={styles.actionRow}>
      <Typography ariaLabel={'actionName'} variant={'text-input-field-r'} className={styles.name}>
        {name}
      </Typography>
      <Typography ariaLabel={'actionValue'} variant={'body-md-regular'} className={styles.value}>
        {message ? message : <span className={styles.placeholder}>{placeholder}</span>}
      </Typography>
    </div>
  )
})
